import AuthApi from '@/services/Api/AuthApi'

export default {
    myself(queryParams) {
        return AuthApi().get('/myself' + queryParams)
    }
}
